import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  IGeojsonRequest,
  IGeojsonRequestDTO,
  IRawGeojsonRequest,
} from "app/bundles/requests/shared/models/geojsonRequest";
import { IServiceRequestProperties } from "app/bundles/requests/shared/models/properties";
import { IRawServiceRequestSummary } from "app/bundles/requests/shared/models/request";
import { environment } from "environments/environment";
import { Observable, of, throwError } from "rxjs";
import {
  catchError,
  concat,
  delay,
  map,
  mergeMap,
  retry,
  retryWhen,
  switchMap,
  take,
  tap,
  timeout,
} from "rxjs/operators";

@Injectable()
export class ApiService {
  constructor(private http: HttpClient) {}

  private addToken(): HttpHeaders {
    const headers = new HttpHeaders();
    return headers.append(
      "Authorization",
      "Bearer " + sessionStorage.getItem("access_token"),
    );
  }

  private addDefaultHeaders(): HttpHeaders {
    const headers: HttpHeaders = this.addToken();
    headers.append("Accept", "application/json");
    return headers.append("Content-type", "application/json");
  }

  private addGeojsonHeaders(): HttpHeaders {
    const headers: HttpHeaders = this.addToken();
    return headers.append("Accept", "application/geo+json");
  }

  public get<R>(endPoint: string) {
    return this.http.get<R>(endPoint, { headers: this.addDefaultHeaders() });
  }

  public getWithGeoJsonHeader(endPoint: string) {
    return this.http.get<IRawServiceRequestSummary>(endPoint, {
      headers: this.addGeojsonHeaders(),
    });
  }

  public getInWorkorderGeojson(endPoint: string) {
    return this.http
      .get<IRawGeojsonRequest>(endPoint, { headers: this.addGeojsonHeaders() })
      .pipe(timeout(environment.apiRequestParameters.httpTimeout));
  }

  public getInServiceRequestGeojson(endPoint: string) {
    return this.http
      .get<IGeojsonRequestDTO<IServiceRequestProperties>>(endPoint, {
        headers: this.addGeojsonHeaders(),
      })
      .pipe(timeout(environment.apiRequestParameters.httpTimeout));
  }

  public post<D = any, B = any>(
    endPoint: string,
    data: D,
  ): Observable<{ body: B; status: number }> {
    return this.http
      .post<B>(endPoint, data, {
        headers: this.addDefaultHeaders(),
        observe: "response",
      })
      .pipe(
        map((result) => {
          return { body: result?.body, status: result?.status };
        }),
        catchError((error) => {
          if ([422].includes(error?.status)) {
            return throwError(() => error);
          }
          alert(`Erreur: ${JSON.stringify(error)}`);

          return throwError(() => error);
        }),
      );
  }

  public put(endPoint: string, data: any) {
    return this.http.put(endPoint, data, { headers: this.addDefaultHeaders() });
  }

  public patch(endPoint: string, data: any) {
    return this.http.patch(endPoint, data, {
      headers: this.addDefaultHeaders(),
    });
  }
}
